import { Base, withDrag } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

const priceFormatter = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

/**
 * PriceRange class.
 */
export default class PriceRange extends withDrag(Base, {
  target: (instance) => instance.$refs.cursor,
}) {
  static config = {
    name: 'PriceRange',
    refs: ['input', 'track', 'thumb', 'cursor', 'current', 'max'],
  };

  /**
   * Value
   */
  set value(value) {
    this.$refs.input.value = `${Number.parseInt(value, 10)}`;
    this.update();
  }

  /**
   * Value
   * @returns {number}
   */
  get value() {
    return Number.parseInt(this.$refs.input.value, 10);
  }

  /**
   * Min
   * @returns {number}
   */
  get min() {
    return this.$refs.input.min;
  }

  /**
   * Max
   * @returns {number}
   */
  get max() {
    return this.$refs.input.max;
  }

  /**
   * Progress
   * @returns {number}
   */
  get progress() {
    return (this.value - this.min) / this.max;
  }

  /**
   * Track width
   * @returns {number}
   */
  get width() {
    return this.$refs.track.offsetWidth;
  }

  /**
   * Update.
   */
  update() {
    const currentContent = priceFormatter.format(this.value);
    this.$refs.current.textContent = currentContent;
    this.$refs.thumb.style.transform = `scaleX(${this.progress})`;
    this.$refs.current.style.width = `${currentContent.length * 0.5}rem`;
    this.$refs.cursor.style.transform = `translateX(${
      this.progress * (this.width - this.$refs.cursor.offsetWidth) +
      this.$refs.cursor.offsetWidth / 2
    }px)`;
  }

  /**
   * Mounted.
   */
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const currentValue = urlParams.get(this.$refs.input.name);
    this.value = currentValue !== null ? currentValue : this.max;
    this.update();
  }

  /**
   * Resized
   */
  resized() {
    this.update();
  }

  /**
   * Dragged.
   * @param {*} props
   */
  dragged(props) {
    toggleClass(this.$refs.cursor, 'cursor-grab', !props.isGrabbing);
    toggleClass(this.$refs.cursor, 'cursor-grabbing', props.isGrabbing);

    if ((props.delta.x < 1 && props.delta.x > -1) || props.delta.x > 16 || props.delta.x < -16) {
      return;
    }

    this.value += (props.delta.x / this.width) * this.max;
  }

  /**
   * On Max click.
   */
  onMaxClick() {
    this.value = this.max;
  }
}
